export const commentActions = {
  CREATE_COMMENT: {
    REQUEST: 'post/create-comment',
    SUCCESS: 'post/create-success',
    FAILURE: 'post/create-failure'
  },
  FETCH_COMMENTS: {
    REQUEST: 'post/fetch-comment',
    SUCCESS: 'post/fetch-success',
    FAILURE: 'post/fetch-failure'
  }
};
